<template>
<div class="login">
  <div class="container">
<div class="global-container">
	<div class="card login-form">
	<div class="card-body">
		<h3 class="card-title text-center">Register on Acadio</h3>
		<div class="card-text">
			<!--
			<div class="alert alert-danger alert-dismissible fade show" role="alert">Incorrect username or password.</div> -->
			<form @submit.prevent="handleSubmit">
				<!-- to error: add class "has-danger" -->
        <div class="form-group">
          <label for="name">Name</label>
          <input v-model="name" type="text" class="form-control form-control-sm" id="name"/>
        </div>
				<div class="form-group">
					<label for="exampleInputEmail1">Email address</label>
					<input v-model="email" type="email" class="form-control form-control-sm" id="exampleInputEmail1" aria-describedby="emailHelp">
				</div>
				<div class="form-group">
					<label for="exampleInputPassword1">Password</label>
					<input v-model="password" type="password" class="form-control form-control-sm" id="exampleInputPassword1">
				</div>
				<button type="submit" class="btn btn-primary btn-block">Register</button>

				<!-- <div class="sign-up">
					Don't have an account? <a href="#">Create One</a>
				</div> -->
			</form>
		</div>
	</div>
</div>
</div>
</div>
  </div>
</template>
<script>
export default {
  name: 'regsiter',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      token: this.$route.query.token
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true
      const { name,email, password, token} = this
      const { dispatch } = this.$store
      if (email && password) {
        dispatch('auth/register', { name,email,password,token})
      }
    }
  },
  watch: {
    '$route'(to,from) {
      // react to route changes...
      this.token = this.$route.query.token
    }
  }

}
</script>
<style lang="stylus" scoped>
// html,body {
// 	height: 100%;
// }

.global-container{
	height:100%;
	display: flex;
	align-items: center;
	justify-content: center;
	// background-color: #f5f5f5;
}

form{
	padding-top: 10px;
	font-size: 14px;
	margin-top: 30px;
}

.card-title{ font-weight:300; }

.btn{
	font-size: 14px;
	margin-top:20px;
}


.login-form{
	width:330px;
	margin:20px;
}

.sign-up{
	text-align:center;
	padding:20px 0 0;
}

.alert{
	margin-bottom:-30px;
	font-size: 13px;
	margin-top:20px;
}
</style>
